

const route = {
    login: '/login',
    otpveryfication: '/otpverification',


    comDashboard: '/c/dashboard',
    cProdInfo: '/c/productInfo',
    cMyProfile: '/c/myprofile',
    comCataLog: '/c/catalogue',
    cSubCatList: '/c/subcategory',
    cProdsList: '/c/products',
    cCart: '/c/cart',
    cProdreqlist: '/c/prodreqlist',
    cProdreqinfo: '/c/prodreqinfo',
    cEditProdReq: '/c/prodreq/edit',
    cNewProdreqlist: '/c/newprodreqlist',
    cCreateNewProdReq: '/c/newprodreqlist/create',
    cNewProdreqinfo: '/c/newprodreqinfo',
    cEditNewProdReq: '/c/newprodreq/edit',
    cProjectList: '/c/projectList',
    cProjInfo: '/c/projectinfo',
    cDeptEmpList: '/c/dept/emplist',
    cDeptCreate: '/c/dept/create',
    cProjEmpList: '/c/project/emplist',
    cDeptEmpCreate: '/c/emp/create',
    cUserProfile: '/c/user/profile',
    cEditDeptEmp: '/c/emp/edit',
    cPolist: '/c/polist',
    cPoInfo: '/c/po/info',
    cDoInfo: '/c/do/info',
    cPoTracking: '/c/po/tracking',

    //Admin Pages--------------------------
    adminDash: '/a/dashboard',
    aProfile: '/a/profile',
    aCataLog: '/a/catalogue',
    aCreateCat: '/a/createcategory',
    aEditCat: '/a/editcategory',
    aSubcategory: '/a/subcategory',
    aCreateSubCat: '/a/createsubcategory',
    aProducts: '/a/products',
    aEditSubcat: '/a/editsubcategory',
    aAddproduct: '/a/addproduct',
    aProduct: '/a/product',
    aEditProd: '/a/editproduct',
    aUpdateProdStock: '/a/prod/updatestock',
    aCompanies: '/a/companies',
    aCreateCom: '/a/createcompany',
    aCompany: '/a/company',
    aEditCom: '/a/editcompany',
    aCreateProj: '/a/createproject',
    aComSubcategory: '/a/com/subcategory',
    aComProdList: '/a/com/products',
    aAddprodtocatalog: '/a/addprodtocatalog',
    aAddprodtocatDetails: '/a/addprodtocatalog/details',
    aComProdInfo: '/a/com/productInfo',
    aUpdateProdAgree: '/a/prod/updateagreedtls',
    aProdApprWaitList: '/a/prodapprlist',
    aProdApprCreateList: '/a/prodapprcreatelist',
    aApprReqProdInfo: '/a/appr/waiting/productInfo',
    aApprCreatedProdInfo: '/a/appr/created/productInfo',
    aApprEditProd: '/a/appr/editProduct',
    aProdStockList: '/a/prod/stocklist',
    aCreateComEmp: '/a/com/createemp',
    aComUserProfile: '/a/com/userprofile',
    aComEditUser: '/a/com/editemp',
    aProjectinfo: '/a/com/projectinfo',
    aEditproject: '/a/editproject',
    aDeptEmpList: '/a/dept/emplist',
    aAmtcEmpList: '/a/amtc/emplist',
    aCreateAmtcEmp: '/a/amtc/createemp',
    aAmtcEmpInfo: '/a/amtc/empinfo',
    aAssSourceEmp: '/a/assign/sourceemp',
    aEditAmtcEmp: '/a/amtc/editemp',
    aPolist: '/a/polist',
    aPoInfo: '/a/po/info',
    aProdreqinfo: '/a/prodreqinfo',
    aNewProdreqlist: '/a/newprodreqlist',
    aNewProdreqinfo: '/a/newprodreqinfo',
    aStorePoList: '/a/s/polist',
    aStorePoInfo: '/a/s/po/info',
    aDoInfo: '/a/do/info',
    aDoCreate: '/a/s/do/create',
    aDoEditInv: '/a/do/editinv',
    aSelCom: '/a/sel/com',
    aPoTracking: '/a/po/tracking',
    aEditPoProd: '/a/po/editpoprod',
    aArchiveprods: '/a/archiveprods',
    aArchiveProdInfo: '/a/archive/productInfo',
    aEditPot: '/a/pot/edit',
    aEditPotInv: '/a/pot/editinv',
    aManualEntry: '/a/pomanual-entry',

    //-----------------------------uma











    reqSubCategory: '/companyuser/subcategory',
    reqProductList: '/companyuser/productlist/',
    reqProfile: '/companyuser/profile',
    reqNotification: '/companyuser/notification',
    reqProductRequest: '/companyuser/productrequest',
    reqNewProductRequest: '/companyuser/newproductrequest',
    reqProductReqList: '/companyuser/prodreqlist',
    reqNewProductReqList: '/companyuser/newprodreqlist',
    reqNewProductInfo: '/companyuser/productinformation',
    reqAddToCart: '/companyuser/addtocart',
    reqAddNewProductReq: '/companyuser/addnewproductrequest',
    reqEditNewProductReq: '/companyuser/editnewproductrequest',
    reqEditProductReq: '/companyuser/editproductrequest',
    addProductRequest: '/companyuser/addproductrequest',
    purchaseOrderList: '/companyuser/purchaseorderlist',
    purchaseOrderDetails: '/companyuser/purchaseorderdetails',
    projectList: '/companyuser/projectlist',
    projectInfo: '/companyuser/projectinfo',
    createDepartment: '/companyuser/createdepartment',
    employeeList: '/companyuser/employeelist',
    assignemployee: '/companyuser/assignemployee',
    userList: '/companyuser/userlist',
    createUser: '/companyuser/createuser',
    editUser: '/companyuser/edituser',
    createCategory: '/amtcuser/createcategory',
    editCategory: '/amtcuser/editcategory',
    createSubCategory: '/amtcuser/createsubcategory',
    editSubCategory: '/amtcuser/editsubcategory',
    createCompany: '/amtcuser/createcompany',

    createProject: '/amtcuser/createproject',
    editProject: '/amtcuser/editproject',
    newEmployeeReqInfo: '/amtcuser/newemployeereqinfo',
    deptReqInfo: '/amtcuser/deptreqinfo',
    companyStock: '/amtcuser/compprodstocklist',
}

export default route
